import { Link } from '@tanstack/react-location'
import React, { useState } from 'react'
import Button from 'shared/components/Button'

const actions = [
  {
    label: 'Add staff',
    to: (property) => `/property/manage/?property_id=${property.id}`,
  },
  {
    label: 'Add vendors',
    to: (property) => `/property/manage/?property_id=${property.id}&add_vendors_modal=true`,
  },
  {
    label: 'Add amenities images',
    to: (property) => `/images?property_id=${property.id}`,
  },
  {
    label: 'Add lines',
    to: (property) => `/line/add?property_id=${property.id}`,
  },
  {
    label: 'Open “Manage Property” screen',
    to: (property) => `/property/manage/?property_id=${property.id}`,
  },
]

function MoreOptions({ property }) {
  const [toggled, setToggled] = useState()
  return (
    <>
      {property && (
        <div className="relative">
          <Button
            variant="secondary"
            onClick={() => {
              setToggled(!toggled)
            }}
          >
            More options
          </Button>
          {toggled && (
            <div className="absolute bg-white bottom-[calc(100%+16px)] shadow-lg">
              <div className='text-lg p-[16px] border-b-[1px]'>More options</div>
              {actions.map((action, index) => (
                <Link
                  className="h-[40px] flex items-center  min-w-max text-[14px] px-[16px] hover:bg-slate-400"
                  to={action.to(property)}
                >
                  {action.label}
                </Link>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default MoreOptions
